module.exports = __webpack_public_path__ + "img/marks.230cadec.webp";